export default function(value) {
  if (!value) return 0;
  return Number(value);
}
